import { jsx as _jsx } from "react/jsx-runtime";
import { Typography as ChameleonTypography } from '@getgo/chameleon-material-ui';
import classNames from 'classnames';
import classes from './index.module.scss';
const Typography = (props) => {
    return _jsx(ChameleonTypography, Object.assign({}, props, { className: classNames(classes.text, props.className) }, { children: props.children }), void 0);
};
export default Typography;
//# sourceMappingURL=index.js.map